"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var InputHelper_1 = require("../../molecules/InputHelper/InputHelper");

var Stateful_1 = require("./Stateful");

var InputToggle =
/** @class */
function (_super) {
  __extends(InputToggle, _super);

  function InputToggle(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (event) {
      _this.props.onChange(event.target.checked, _this.props.name, event);
    };

    _this.uuid = _this.props.id || uniqid_1["default"]("lsg--" + _this.constructor.name.toLowerCase());
    return _this;
  }

  InputToggle.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        value = _a.value,
        label = _a.label,
        helperText = _a.helperText,
        disabled = _a.disabled,
        children = _a.children,
        inputType = _a.inputType,
        invalid = _a.invalid;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "inputtoggle", invalid && CSSPrefix_1.lsgPre + "inputtoggle__invalid", className])
    }, React.createElement("input", {
      id: this.uuid,
      className: CSSPrefix_1.lsgPre + "inputtoggle-native-control",
      type: inputType,
      checked: value,
      disabled: disabled,
      onChange: this.onChange
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputtoggle-container"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputtoggle-background"
    }, children || React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "inputtoggle-knob"
    })), label && React.createElement("label", {
      className: CSSPrefix_1.lsgPre + "inputtoggle-label",
      htmlFor: this.uuid
    }, label), helperText && React.createElement(InputHelper_1.InputHelper, {
      className: CSSPrefix_1.lsgPre + "inputtoggle-helpertext",
      helperText: helperText
    })));
  };

  InputToggle.defaultProps = {
    onChange: function onChange() {
      /* empty */
    },
    inputType: "checkbox"
  };
  InputToggle.Stateful = Stateful_1.Stateful;
  return InputToggle;
}(React.Component);

exports.InputToggle = InputToggle;